import { render, staticRenderFns } from "./EditBlockTabs.vue?vue&type=template&id=207c0e9a&"
import script from "./EditBlockTabs.vue?vue&type=script&lang=js&"
export * from "./EditBlockTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports